import type { VariableFormat } from './census-variables';

type Lang = 'es' | 'en';

export function formatValue(
  value: number | null | undefined,
  format: VariableFormat,
  lang: Lang,
  noData: string,
): string {
  if (value == null || !Number.isFinite(value)) return noData;
  const locale = lang === 'es' ? 'es-PR' : 'en-US';
  switch (format) {
    case 'percent':
      return new Intl.NumberFormat(locale, {
        style: 'percent',
        minimumFractionDigits: 1,
        maximumFractionDigits: 1,
      }).format(value);
    case 'count':
      return new Intl.NumberFormat(locale, {
        maximumFractionDigits: 0,
      }).format(value);
    case 'currency':
      return new Intl.NumberFormat(locale, {
        style: 'currency',
        currency: 'USD',
        maximumFractionDigits: 0,
      }).format(value);
    case 'years':
      return lang === 'es' ? `${Math.round(value)} años` : `${Math.round(value)} yrs`;
  }
}

export function formatShort(
  value: number | null | undefined,
  format: VariableFormat,
  lang: Lang,
): string {
  if (value == null || !Number.isFinite(value)) return '—';
  if (format === 'percent') return `${(value * 100).toFixed(1)}%`;
  if (format === 'currency') {
    if (value >= 1000) return `$${(value / 1000).toFixed(0)}k`;
    return `$${value}`;
  }
  if (format === 'count') {
    if (value >= 1000) return `${(value / 1000).toFixed(1)}k`;
    return String(Math.round(value));
  }
  return lang === 'es' ? `${Math.round(value)}a` : `${Math.round(value)}y`;
}
